import type { ApiClient } from "@/lib/api";

export const deleteSecret = async ({
  client,
  id,
}: {
  client: ApiClient;
  id: string;
}) => {
  const { data } = await client.delete(`/secrets/${id}`);
  return data;
};
